// extracted by mini-css-extract-plugin
export default {"container":"Q8Tn6_container","image-shadow":"j2flD_image-shadow","image-radius":"kgGKL_image-radius","image":"OmZgQ_image","arrow":"CHuCk_arrow"};